import { render, staticRenderFns } from "./BranchesEditBranch.vue?vue&type=template&id=240e3596&"
import script from "./BranchesEditBranch.vue?vue&type=script&lang=js&"
export * from "./BranchesEditBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports